import { DataTable } from "@/components/data-table";
import { Form, useForm } from "@/components/form";
import { useGetAllArticulosQuery } from "@/features/inventario/articulos/api/get-all-articulos";
import { formatString } from "@/shared/formats";
import { Articulo } from "@/shared/types/articulo";
import { IconButton, Stack, StackProps } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import { getRubro } from "@/features/auxiliar/rubros/api/get-rubro";
import { getAllRubros } from "@/features/auxiliar/rubros/api/get-all-rubros";
import { useFilters } from "@/components/filters";

interface ArticuloSearchProps extends StackProps {
    onArticuloSelect?: (articulo: Articulo) => void
}

export default function ArticuloMovimientoArticuloManualSearch({
    onArticuloSelect,
    ...props
}: ArticuloSearchProps) {
    const filterData = useFilters({
        useURL: false,
        filters: [
            { type: "string", label: "Nombre", name: "nombre" },
            { type: "model", label: "Rubro", name: "rubroId", get: getRubro, getAll: getAllRubros },
            { type: "string", label: "Código", name: "codigo" },
            { type: "string", label: "N° Item", name: "numeroItem" },
            { type: "pagination" }
        ]
    })

    const queryResult = useGetAllArticulosQuery(filterData.filterData);

    const filterForm = useForm({
        defaultValues: filterData.filterData,
        onSubmit: ({ value }) => filterData.setFilterData(value),
        closeModalOnSubmit: false,
        submitOnce: false,
    })

    return <Stack minHeight={"70vh"} gap={3} {...props}>
        <Form form={filterForm} direction={"row"} flexWrap={"wrap"} gap={2}>
            <Form.TextField name="nombre" label="Nombre" size="small" />
            <Stack flexBasis={"200px"}>
                <Form.ModelComboBox name="rubroId" label="Rubro" size="small" get={getRubro} getAll={getAllRubros} />
            </Stack>
            <Form.TextField name="codigo" label="Código" size="small" />
            <Form.TextField name="numeroItem" label="N° Item" size="small" />
            <Form.SubmitButton>Filtrar</Form.SubmitButton>
        </Form>
        <DataTable flex={1}>
            <DataTable.Content
                fit="flex"
                rows={queryResult.data?.result}
                loading={queryResult.isFetching}
                columns={[
                    { key: "nombre", header: "Nombre", render: row => formatString(row.nombre) },
                    { key: "rubro", header: "Rubro", render: row => formatString(row.rubroNombre) },
                    { key: "codigo", header: "Código", render: row => formatString(row.codigo) },
                    { key: "numeroItem", header: "N° de Item", render: row => formatString(row.numeroItem) },
                    {
                        header: "", align: "center", width: "auto",
                        render: a => <IconButton onClick={() => onArticuloSelect && onArticuloSelect(a)}>
                            <AddIcon />
                        </IconButton>
                    }
                ]}
            />
            <DataTable.Pagination queryResult={queryResult} filterData={filterData} />
        </DataTable>
    </Stack>
}
